import { render, staticRenderFns } from "./editMediaBlock.vue?vue&type=template&id=9d04e03a"
import script from "./editMediaBlock.vue?vue&type=script&lang=js"
export * from "./editMediaBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports